import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  root: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 64,
    maxWidth: '100%',
    margin: '0 auto 5.5rem',
    padding: 0,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'stretch',
      gap: 16,
    },
    [breakpoints.up('lg')]: {
      justifyContent: 'space-between',
      gap: 'unset',
      width: 992,
    },
    '&.child': {
      gap: '2.25rem',
      marginBottom: '1.25rem',
    },
  },
  item: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 280,
    margin: 0,
    padding: '1rem 2rem 1rem',
    border: `2px solid ${palette.common.white}`,
    borderRadius: 24,
    background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.5) 0, rgba(166, 231, 255, 0.5) 100%)',
    boxShadow: '2px 4px 6px 1px rgba(0, 0, 0, 0.25)',
    [breakpoints.up('md')]: {
      width: 360,
      padding: '44px 16px 20px 20px',
      borderRadius: 44,
    },
    [breakpoints.up('lg')]: {
      width: 428,
    },
    '&.child': {
      width: 355,
      maxWidth: '100%',
      padding: '1rem 2.75rem 1.125rem',
      boxShadow: '2px 3px 7px 1px rgba(10, 124, 193, 0.2)',
    },
  },
}));
